<template>
  <div>
    <div v-if="loading">
      <div class="spinner text-xs-center" style="margin-top: 80px;">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </div>
    <template v-else>
      <v-expansion-panel v-model="panel" expand>
        <v-expansion-panel-content v-for="(item, i) in platFormUpdate" :key="i">
          <template v-slot:header>
            <div style="font-size: 17px;">{{ item.header }}</div>
          </template>
          <v-card v-for="(text, j) in item.text" :key="j">
            <v-card-title
              @click="
                item.image
                  ? openDialog(item.image, item.id, text.link)
                  : openLinknewtab(text.link, item.id)
              "
              style="font-weight: bold; border-radius: 23px 23px 0px 0px;"
              :style="'cursor: pointer'"
              class="grey lighten-3 pb-1"
              primary-title
            >
              {{ text.title }}
            </v-card-title>
            <v-card-text
              :style="j != Object.keys(item.text).length - 1 ? 'margin-bottom: 8px;' : ''"
              class="grey lighten-3 pt-0"
              style="border-radius: 0px 0px 23px;"
            >
              {{ text.message }}
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <div class="text-xs-right">
          <v-btn flat icon small fab @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-img :src="`${this.urlImage}${image}`"></v-img>
        <v-flex xs4 class="d-flex justify-center mt-4 pb-2 mx-auto w-100" v-if="link">
          <v-btn color="primary" :href="link" target="_blank" rel="noopener noreferrer" link>
            {{ $t('Read more about how to use') }}
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      urlImage: '/static/img/platform-update/',
      panel: [],
      loading: true,
      dialog: false,
      image: '',
      link: '',
      platFormUpdate: []
      // platFormUpdate: [
      //   {
      //     id: '51',
      //     status: true,
      //     header: '23 พฤษภาคม 2023',
      //     image: 'nickname-feat.png',
      //     text: [
      //       {
      //         title: 'สร้างชื่อเล่นให้ลูกค้าในระบบหลังบ้าน',
      //         message:
      //           'สร้างชื่อเล่นของลูกค้าเพื่อใช้ในการค้นหาได้ง่ายขึ้น โดยในมุมลูกค้าจะไม่เห็นชื่อที่เราตั้งไว้ สามารถสร้างชื่อเล่นให้ลูกค้าของคุณได้ที่หน้ารวมแชท และหน้าวิเคราะห์',
      //         link: ''
      //       }
      //     ]
      //   },
      //   {
      //     id: '50',
      //     status: true,
      //     header: '27 มีนาคม 2023',
      //     text: [
      //       {
      //         title: 'คิดประโยคในบทสนทนาไม่ออก ให้ ChatGPT ช่วยได้',
      //         message:
      //           'เราได้นำผู้ช่วยคิดประโยคคำถามหรือประโยคฝั่งซ้าย(คำที่ลูกค้าจะพิมพ์มา)อย่าง ChatGPT มาไว้ให้ทีนี่แล้ว มาสร้างบทสนทนาของคุณให้มีประสิทธิภาพมากขึ้นกัน',
      //         link: 'https://blog.zwiz.ai/chatgpt-zwizai/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '49',
      //     status: true,
      //     header: '21 มีนาคม 2023',
      //     text: [
      //       {
      //         title: 'Follow-Up ติดตามลูกค้าผ่านไลน์ได้มากกว่า 24 ชม.',
      //         message:
      //           'ให้บอทช่วยตามลูกค้าผ่านช่องทางไลน์ สามารถทำได้มากกว่า 24 ชม. แล้ว ลูกค้าที่หายไป อ่านแต่ไม่ตอบ สั่งของแล้วเงียบหาย ให้แชทบอทช่วยตามทันที',
      //         link:
      //           'https://blog.zwiz.ai/follow-up-%e0%b8%95%e0%b8%b2%e0%b8%a1%e0%b8%a5%e0%b8%b9%e0%b8%81%e0%b8%84%e0%b9%89%e0%b8%b2%e0%b9%83%e0%b8%ab%e0%b9%89%e0%b8%81%e0%b8%a5%e0%b8%b1%e0%b8%9a%e0%b8%a1%e0%b8%b2%e0%b8%8b%e0%b8%b7%e0%b9%89/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '48',
      //     status: true,
      //     header: '23 กุมภาพันธ์ 2023',
      //     text: [
      //       {
      //         title: 'Update หน้าตาระบบหลังบ้าน ใช้งานสะดวก สวยงามยิ่งขึ้น',
      //         message:
      //           'ส่วนที่มีการอัปเดตและเปลี่ยนแปลงจะเป็นในส่วนของเมนูและหน้าตาการใช้งาน ทำให้เราเห็นภาพรวมการใช้งานระบบของเรามากขึ้น',
      //         link: 'https://blog.zwiz.ai/cms-update/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '47',
      //     status: true,
      //     header: '2 กุมภาพันธ์ 2023',
      //     text: [
      //       {
      //         title: 'เพิ่มแพลตฟอร์มเชื่อมต่อแชทบอทบน WhatsApp Business',
      //         message:
      //           'ขยายแพลตฟอร์มรัวๆ กับ WhatsApp Business ใครมีกลุ่มลูกค้าต่างชาติ หรือคิดจะขยายตลาดไปต่างประเทศรีบมาติดตั้งด่วนๆ พร้อมขยายฐานลูกค้าได้แล้ววันนี้!',
      //         link: 'https://blog.zwiz.ai/whatsapp-messages/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '46',
      //     status: true,
      //     header: '23 มกราคม 2023',
      //     text: [
      //       {
      //         title: 'อัปเดตสิทธิการใช้งานตามบทบาท FB บนระบบ Zwiz.AI',
      //         message:
      //           'ไม่จำเป็นต้องเป็นบทบาท ผู้ดูแล(Admin) อย่างเดียวแล้วที่เป็นคนติดตั้งแชทบอทในครั้งแรก เพราะผู้แก้ไข/ผู้ควบคุมก็ทำได้แล้ว หรือแม้แต่เวลาบอทหลุด(Token Expire) ผู้แก้ไข/ผู้ควบคุมก็สามารถล็อกอินให้บอทกลับมาทำงานได้ทันที',
      //         link: 'https://tinyurl.com/2p8p9xsu'
      //       }
      //     ]
      //   },
      //   {
      //     id: '45',
      //     status: true,
      //     header: '11 มกราคม 2023',
      //     text: [
      //       {
      //         title: 'เชื่อมต่อแชทบอทบน Google Messages เจ้าแรกของประเทศ',
      //         message:
      //           'ได้เวลาขยายแพลตฟอร์ม! กับ Google Messages ไม่ว่าจะค้นหาผ่าน Google Search หรือค้นหาร้านผ่าน Google Map แล้วกด "แชท" เข้ามา บอททำงานให้ทันที!',
      //         link: 'https://blog.zwiz.ai/google-messages/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '44',
      //     status: true,
      //     header: '14 พฤศจิกายน 2022',
      //     text: [
      //       {
      //         title: 'เรียกชำระเงินลูกค้าในแชทด้วย Meta Pay ',
      //         message:
      //           'ทำให้ประสบการณ์การชำระเงินของลูกค้าง่ายขึ้น ไม่ว่าจะเป็นการโอนเงินผ่านธนาคาร หรือ QR Code แบบไม่เสียค่าธรรมเนียม ผ่าน Meta Pay',
      //         link: 'https://blog.zwiz.ai/metapay-registration/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '43',
      //     status: true,
      //     header: '14 พฤศจิกายน 2022',
      //     text: [
      //       {
      //         title: 'ส่งออกไฟล์ Excel แบบกำหนดเอง',
      //         message:
      //           'เลือกข้อมูลหรือคอลัมน์ที่ต้องการแสดงในไฟล์ Excel เพื่อการส่งออกไฟล์ จากหน้าสรุปออเดอร์ลูกค้าได้ตามที่ร้านค้าต้องการ',
      //         link: 'https://blog.zwiz.ai/customize-excel/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '42',
      //     status: true,
      //     header: '8 พฤศจิกายน 2022',
      //     text: [
      //       {
      //         title: 'ตรวจสลิปปลอมเมื่อลูกค้าซื้อสินค้าในร้านค้า',
      //         message:
      //           'พร้อมรับมือสลิปปลอมทั้งใน Shop และในแชทแล้ว หายห่วงสลิปปลอม สลิปซ้ำ ยอดเงินไม่ตรง แอดมินตรวจสอบได้ทันทีเพียงคลิกเดียว!',
      //         link: 'https://blog.zwiz.ai/slip-verification/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '41',
      //     status: true,
      //     header: '19 ตุลาคม 2022',
      //     text: [
      //       {
      //         title: 'เชื่อมต่อแชทบอทกับ LINE Shopping (My Shop)',
      //         message:
      //           'ดึงสินค้าจาก LINE Shopping (My Shop) มาแสดงเป็นแค็ตตาล็อกให้เลือกในแชท พร้อมส่งต่อลูกค้าไปยังร้านค้าใน LINE Shopping (My Shop) ได้ทันที',
      //         link: 'https://blog.zwiz.ai/lineshopping/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '40',
      //     status: true,
      //     header: '29 กันยายน 2022',
      //     text: [
      //       {
      //         title: 'ตรวจสอบสลิปด้วย Slip Verfication',
      //         message:
      //           'หมดปัญหาเรื่องสลิปปลอม สลิปซ้ำ เพราะตอนนี้ต่อให้ลูกค้าส่งสลิปมาเป็นร้อยคนก็ตรวจได้หมด ด้วยฟีเจอร์ "ตรวจสอบสลิป (Slip Verification)"',
      //         link: 'https://blog.zwiz.ai/slip-verification/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '39',
      //     status: true,
      //     header: '23 กันยายน 2022',
      //     text: [
      //       {
      //         title: 'เชื่อมต่อระบบขนส่ง J&T Express',
      //         message:
      //           'เชื่อมระบบขนส่ง J&T Express  พร้อมส่งเลขพัสดุอัตโนมัติ และอัปเดตสถานะการจัดส่งในแชท',
      //         link: 'https://blog.zwiz.ai/zwizai-x-jtexpress/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '38',
      //     status: true,
      //     header: '23 กันยายน 2022',
      //     text: [
      //       {
      //         title: 'เชื่อมต่อระบบขนส่ง SCG Express',
      //         message:
      //           'เชื่อมระบบขนส่ง SCG Express พร้อมส่งเลขพัสดุอัตโนมัติ และอัปเดตสถานะการจัดส่งในแชท',
      //         link: 'https://blog.zwiz.ai/zwizai-x-scgexpress/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '37',
      //     status: true,
      //     header: '23 กันยายน 2022',
      //     text: [
      //       {
      //         title: 'ตอบกลับคอมเมนต์ใน IG Reels',
      //         message:
      //           'ซีวิซเอไอสามารถตอบกลับคอมเมนต์ใน IG Reels ได้แล้ว พร้อมดูดคอมเมนต์เข้ามาใน Direct Message ได้ทันที เก็บลูกค้าได้หมดยอดขายเพิ่มชัวร์',
      //         link: 'https://blog.zwiz.ai/replycomment-igreels/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '36',
      //     status: true,
      //     header: '9 กันยายน 2022',
      //     text: [
      //       {
      //         title: 'เชื่อมต่อบอทกับโฆษณาแบบ JSON',
      //         message:
      //           'ให้บอทช่วยตอบกลับลูกค้าจากโฆษณาแบบ Click to Messenger Ads ได้ทันที ด้วยฟีเจอร์เชื่อมบอทกับโฆษณาแบบ JSON code ผ่านหลังบ้านซีวิซ',
      //         link: 'https://blog.zwiz.ai/messenger-ads-simulator/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '35',
      //     status: true,
      //     header: '1 กันยายน 2022',
      //     text: [
      //       {
      //         title: 'เปิดบิล จากฝั่งแอดมินพร้อมใส่ส่วนลด',
      //         message:
      //           'เปิดบิลให้ลูกค้าจากฝั่งร้านค้า พร้อมใส่โค้ดส่วนลดให้ลูกค้าในขณะเปิดบิลได้ทันที และยังมีการแสดงผลชื่อแอดมินที่ทำการเปิดบิลในระบบหลังบ้านได้อีกด้วย',
      //         link: 'https://blog.zwiz.ai/create-order-by-admin/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '34',
      //     status: true,
      //     header: '20 พฤษภาคม 2022',
      //     text: [
      //       {
      //         title: 'บรอดแคสต์แบบพิเศษ Marketing Messages',
      //         message:
      //           'บรอดแคสต์แบบพิเศษ Marketing Messages เริ่มใช้งานอย่างเป็นทางการแล้ว สามารถส่งบรอดแคสต์ได้ทุกประเภทข้อความ เมื่อลูกค้ากดปุ่ม "รับข้อความ"',
      //         link: 'https://blog.zwiz.ai/specialbroadcast/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '33',
      //     status: true,
      //     header: '12 พฤษภาคม 2022',
      //     text: [
      //       {
      //         title: 'ZWIZ.AI X Zortout',
      //         message:
      //           'ZWIZ.AI ได้เชื่อมต่อกับ Zort ซึ่งให้บริการเกี่ยวกับการจัดการสต๊อกสินค้า ทำให้ร้านค้าสามารถบริหารออเดอร์ได้ง่ายขึ้น แม้ลูกค้าจะสั่งซื้อมาจากหลากหลายช่องทางก็ตาม',
      //         link: 'https://blog.zwiz.ai/zortout_ordermanagement/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '32',
      //     status: true,
      //     header: '10 พฤษภาคม 2022',
      //     text: [
      //       {
      //         title: 'Growth Tools เครื่องมือเพิ่มยอดขาย',
      //         message:
      //           '9 เครื่องมือลับ ที่นักการตลาดไม่ควรพลาด เพราะจะทำให้ธุรกิจคุณเติบโตแบบก้าวกระโดด และนำไปประยุกต์ให้เกิดประโยชน์ในธุรกิจของคุณได้ไม่เหมือนใคร',
      //         link: 'https://blog.zwiz.ai/growth-tools/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '31',
      //     status: true,
      //     header: '25 มีนาคม 2022',
      //     text: [
      //       {
      //         title: 'วิธีสร้างกลุ่มเป้าหมาย Facebook จากแชทบอท',
      //         message:
      //           'สร้างกลุ่มเป้าหมาย ในการยิงโฆษณา Facebook แบบกำหนดเอง (Custom Audience) เพียงแค่มี Facebook Ads Account และ แชทบอทจาก ZWIZ.AI ก็สามารถเชื่อมต่อตัวจัดการโฆษณาได้แล้ว',
      //         link: 'https://blog.zwiz.ai/custom-audience'
      //       }
      //     ]
      //   },
      //   {
      //     id: '30',
      //     status: true,
      //     header: '2 มีนาคม 2022',
      //     text: [
      //       {
      //         title: 'วิธีการบรอดแคสต์แบบพิเศษ',
      //         message:
      //           'บรอดแคสต์แบบใหม่ ส่งข้อความหาลูกค้าผ่าน Messenger ได้ฟรี ไม่จำกัดประเภทข้อความ',
      //         link: 'https://blog.zwiz.ai/specialbroadcast/?utm_source=NTN_CMS'
      //       }
      //     ]
      //   },
      //   {
      //     id: '29',
      //     status: true,
      //     header: '23 กุมภาพันธ์ 2022',
      //     text: [
      //       {
      //         title: 'Follow Up ตามลูกค้าในแชทโดยอัตโนมัติ',
      //         message:
      //           'ZWIZ.AI สามารถ Follow up ตามลูกค้าให้กลับมาซื้อสินค้า, ยืนยันออเดอร์ หรือแม้แต่ Support Service หลังการขายได้แล้ววันนี้',
      //         link:
      //           'https://blog.zwiz.ai/follow-up-%E0%B8%95%E0%B8%B2%E0%B8%A1%E0%B8%A5%E0%B8%B9%E0%B8%81%E0%B8%84%E0%B9%89%E0%B8%B2%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%81%E0%B8%A5%E0%B8%B1%E0%B8%9A%E0%B8%A1%E0%B8%B2%E0%B8%8B%E0%B8%B7%E0%B9%89/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '28',
      //     status: true,
      //     header: '12 กุมภาพันธ์',
      //     text: [
      //       {
      //         title: 'ตัดสต็อคสินค้าทันทีหลังจาก CF',
      //         message:
      //           'ร้านค้าที่สินค้ามีจำนวนจำกัดต้องการให้ลูกค้าจองสินค้า ตอนนี้สามารถทำได้แล้วโดยใช้ระบบตัดสต็อคสินค้าทันทีหลังจาก ลูกค้า CF มา',
      //         link:
      //           'https://blog.zwiz.ai/%E0%B8%9F%E0%B8%B5%E0%B9%80%E0%B8%88%E0%B8%AD%E0%B8%A3%E0%B9%8C%E0%B8%95%E0%B8%B1%E0%B8%94%E0%B8%AA%E0%B8%95%E0%B9%87%E0%B8%AD%E0%B8%84%E0%B8%AA%E0%B8%B4%E0%B8%99%E0%B8%84%E0%B9%89%E0%B8%B2%E0%B8%97/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '27',
      //     status: true,
      //     header: '1 กุมภาพันธ์ 2022',
      //     text: [
      //       {
      //         title: 'ZWIZ.AI X Ketshopweb',
      //         message:
      //           'ตอนนี้ ZWIZ.AI ได้ทำการพัฒนาระบบการเชื่อมต่อกับ Ketshopweb แล้ว  สามารถ syn stock กันได้แล้ว',
      //         link: 'https://blog.zwiz.ai/zwiz-ai-x-ketshopweb/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '26',
      //     status: true,
      //     header: '25 มกราคม 2022',
      //     text: [
      //       {
      //         title: 'Alt Text',
      //         message:
      //           'ระบบ ZWIZ.AI สามารถใส่ Alt Text (Alternative Text) ได้แล้วน้า ALT Text คือคำอธิบายรูปภาพ menu list, Line Image Map,Flex Message ที่แสดงบน Line OA',
      //         link: 'https://blog.zwiz.ai/alt-text-คำอธิบายรูปภาพ/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '25',
      //     status: true,
      //     header: '22 มกราคม 2022',
      //     text: [
      //       {
      //         title: 'Live ผ่าน IG',
      //         message:
      //           'แม่ค้า IG โปรดทราบ !! ตอนนี้ระบบดึงคอมเมนต์ ผ่าน LIVE ใน IG ได้แล้ว ลองเข้าไปเล่นกันเลย',
      //         link: 'https://blog.zwiz.ai/instagram-bot/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '24',
      //     status: true,
      //     header: '17 มกราคม 2022',
      //     text: [
      //       {
      //         title: 'Sokochan',
      //         message:
      //           'ZWIZ.AI ได้เชื่อมต่อกับ Sokochan ที่เป็น E-Commerce Fulfillment เรียบร้อยแล้ว สำหรับร้านค้าที่ต้องการมีคลังสินค้าออนไลน์สำหรับธุรกิจของคุณ สามารถเชื่อมต่อสต็อกสินค้าและการสั่งซื้อเข้าด้วยกันได้เลย',
      //         link: 'https://tinyurl.com/y3gupejf'
      //       }
      //     ]
      //   },
      //   {
      //     id: '23',
      //     status: true,
      //     header: '12 มกราคม 2022',
      //     text: [
      //       {
      //         title: 'Line Beacon',
      //         message:
      //           'เป็นเทคโนโลยีที่ใช้สำหรับการส่งข้อความในไลน์ผ่าน Bluetooth ได้ฟรี โดยไม่เสียค่า Push Message โดยเมื่อเราเดินเข้าไปในรัศมีที่มี LINE Beacon ส่งสัญญาณถึง ก็จะได้รับข้อความ รูปภาพ ที่ร้านค้าตั้งไว้ทันที',
      //         link: 'https://blog.zwiz.ai/line-beacon/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '22',
      //     status: true,
      //     header: '15 พฤศจิกายน 2021',
      //     text: [
      //       {
      //         title: 'ดึงข้อมูลอัพเดทบัญชีในไลน์และเฟสบุ๊ค',
      //         message:
      //           'ดึงข้อมูลและรูปโปรไฟล์ล่าสุดในไลน์และเฟสบุ๊คบนระบบ ZWIZ ได้ง่ายๆ เพียงไม่กี่คลิกระบบก็จะอัพเดทข้อมูลโปรไฟล์เพจของคุณเป็นเวอร์ชั่นล่าสุดได้ทันที',
      //         link: 'https://tinyurl.com/y5oe25zm'
      //       }
      //     ]
      //   },
      //   {
      //     id: '21',
      //     status: true,
      //     header: '5 พฤศจิกายน 2021',
      //     text: [
      //       {
      //         title: 'ลูกค้าแก้ไขที่อยู่ได้เอง',
      //         message:
      //           'ถ้าหากเปิดการใช้ฟีเจอร์นี้ ลูกค้าจะสามารถตรวจสอบสถานะและแก้ไขที่อยู่การจัดส่งได้เองผ่านแชทได้',
      //         link: 'https://blog.zwiz.ai/tutorial-6-shopservice/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '20',
      //     status: true,
      //     header: '29 ตุลาคม 2021',
      //     text: [
      //       {
      //         title: 'บอท Line OA ช่วยตอบในกลุ่ม Line',
      //         message:
      //           'กลุ่มไลน์ที่คุยงานกับลูกค้า สามารถนำเจ้าบอท Line OA นี้ดึงเข้ากลุ่มใน Line แล้วช่วยเราตอบได้เลย แถมยังสามารถ ดูแชทที่ถาม - ตอบ และ จัดการกลุ่ม ผ่านทางหน้ารวมแชทได้อีกด้วย',
      //         link: 'https://blog.zwiz.ai/ระบบ-all-in-1-chat-รวมแชทในที่เดียว/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '19',
      //     status: true,
      //     header: '29 กันยายน 2021',
      //     text: [
      //       {
      //         title: 'คิดค่าจัดส่งตามพื้นที่ห่างไกล',
      //         message:
      //           'ตอนนี้สามารถคิดค่าจัดส่งแยกตามปริมณฑล ต่างจังหวัด และพื้นที่ห่างไกลได้แล้วนะคะ ระบบ Zwiz จะแยกตามรหัสไปรษณีย์ที่ได้ข้อมูลมาจากขนส่งโดยตรงเลย ทำให้ไม่ต้องกังวลเรื่องแบกรับค่าใช้จ่ายให้ลูกค้าในพื้นที่ห่างไกลอีกแล้ว',
      //         link: 'https://blog.zwiz.ai/tutorial-6-shopservice/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '18',
      //     status: true,
      //     header: '18 กันยายน 2021',
      //     text: [
      //       {
      //         title: 'การติดตั้ง LINE Image Map ในแชทบอท',
      //         message:
      //           'สร้างการตอบกลับแชทบอทบนแพลตฟอร์ม LINE ให้ตอบเป็น LINE Image Map เพียงแค่นำไฟล์รูปที่เราต้องการแล้วอัพโหลดเข้าระบบได้ง่ายๆ หรือถ้าต้องการให้กดรูปภาพแล้วลิงก์ไปยังเว็บไซต์ต่างๆ ก็สามารถใส่ลิงก์ URL เพิ่มเข้าไปได้เลย',
      //         link: 'https://tinyurl.com/ygc8v7xw'
      //       }
      //     ]
      //   },
      //   {
      //     id: '17',
      //     status: true,
      //     header: '7 กันยายน 2021',
      //     text: [
      //       {
      //         title: 'Rich Menu บน Line Official Account',
      //         message:
      //           'สร้างริชเมนูบนไลน์ได้เองฉบับง่ายด้วย Rich Menu Creator by ZWIZ.AI ระบบสามารถปรับแต่งรูปแบบริชเมนูให้หลากหลายขึ้น เช่น เพิ่มริชเมนูแบบต่อเนื่องได้, สร้างปุ่มกด action ในรูปได้แบบอิสระ แถมยังมีระบบวิเคราะห์ให้ด้วย ว่าลูกค้ากดปุ่มไหนไปบ้าง ทดลองใช้ฟรี 30 วัน',
      //         link: 'https://tinyurl.com/yej68znq'
      //       }
      //     ]
      //   },
      //   {
      //     id: '16',
      //     status: true,
      //     header: '2 สิงหาคม 2021',
      //     text: [
      //       {
      //         title: 'Template บทสนทนา',
      //         message:
      //           'ชุดบทสนทนาที่มีการเทรนคำไว้เป็นที่เรียบร้อย ผู้ใช้งานสามารถกดเลือกหัวข้อที่ต้องการไปสร้างบทสนทนาได้เลย เพียงใส่คำตอบของทางเพจลงไปเท่านั้น',
      //         link: 'https://blog.zwiz.ai/เทมเพลตบทสนทนา-conversation-templates/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '15',
      //     status: true,
      //     header: '29 กรกฏาคม 2021',
      //     text: [
      //       {
      //         title: 'แชทบอทตอบบน Instagram',
      //         message: 'นอกจากแชทบอทจะตอบบนเฟสบุ๊คและบนไลน์ได้ ตอนนี้แชทบอทสามารถ “ตอบบนไอจี” ได้',
      //         link: 'https://blog.zwiz.ai/instagram-bot/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '14',
      //     status: true,
      //     header: '19 กรกฏาคม 2021',
      //     text: [
      //       {
      //         title: 'ตั้งค่าตัวเลือกการกรอกที่อยู่เพิ่มเติม',
      //         message:
      //           'สำหรับร้านค้าที่ไม่ได้ขายสินค้า แต่เป็นบริการ จะสามารถเลือกตั้งค่าในหน้าบริการร้านค้าครบวงจรได้ ว่าต้องการให้ลูกค้ากรอกที่อยู่หรือไม่ หรือเปิดตัวเลือกเพิ่มเติมในการกรอก อีเมล์ ไอดีไลน์ หรือเบอร์โทรเท่านั้น',
      //         link:
      //           'https://blog.zwiz.ai/%E0%B8%95%E0%B8%B1%E0%B8%A7%E0%B9%80%E0%B8%A5%E0%B8%B7%E0%B8%AD%E0%B8%81%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%81%E0%B8%A3%E0%B8%AD%E0%B8%81%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '13',
      //     status: true,
      //     header: '7 กรกฏาคม 2021',
      //     text: [
      //       {
      //         title: 'ระบบใบเสร็จ/ใบกำกับภาษี',
      //         message:
      //           'ร้านค้าสามารถเลือกเปิดฟีเจอร์เพิ่มเติมเพื่อให้ลูกค้าสามารถขอและกรอกชื่อที่อยู่ในการออกใบเสร็จหรือใบกำกับภาษีได้ ',
      //         link:
      //           'https://blog.zwiz.ai/%e0%b8%a3%e0%b8%b0%e0%b8%9a%e0%b8%9a%e0%b9%83%e0%b8%9a%e0%b9%80%e0%b8%aa%e0%b8%a3%e0%b9%87%e0%b8%88-'
      //       }
      //     ]
      //   },
      //   {
      //     id: '12',
      //     status: true,
      //     header: '28 มิถุนายน 2021',
      //     text: [
      //       {
      //         title: 'เซลเพจ (Sale Page)',
      //         message:
      //           'ฟีเจอร์ที่ช่วยตอบโจทย์ร้านค้าของคุณได้มากยิ่งขึ้น สามารถคัดลอกลิงก์ร้านค้าไปโพสต์ขายสินค้าเพื่อปิดการขายได้ง่ายยิ่งขึ้น และมีตัวเลือกรูปแบบแนะนำเพื่อช่วยในการตั้งค่าที่สะดวก เลือกธีมสีได้ ใส่รูปภาพ และเลือกสไตล์เฉพาะร้านของคุณ',
      //         link:
      //           'https://blog.zwiz.ai/%e0%b8%aa%e0%b8%a3%e0%b9%89%e0%b8%b2%e0%b8%87%e0%b8%ab%e0%b8%99%e0%b9%89%e0%b8%b2%e0%b9%80%e0%b8%a7%e0%b9%87%e0%b8%9a%e0%b8%82%e0%b8%b2%e0%b8%a2%e0%b8%82%e0%b8%ad%e0%b8%87%e0%b8%84%e0%b8%a3%e0%b8%9a/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '11',
      //     status: true,
      //     header: '8 มิถุนายน 2021',
      //     text: [
      //       {
      //         title: 'ตอบคอมเมนต์ตามคีย์เวิร์ด',
      //         message:
      //           'สามารถเลือกตั้งค่าให้บอทตอบตามโพสต์ที่มี”คีย์เวิร์ด” ที่หน้าเพจใส่ไว้ในรายละเอียดได้ โดยการตอบกลับจะไปตอบสำหรับทุกโพสต์ที่เรามีการตั้งค่าคีย์เวิร์ดให้ตอบ',
      //         link:
      //           'https://blog.zwiz.ai/%e0%b8%95%e0%b8%ad%e0%b8%9a%e0%b8%81%e0%b8%a5%e0%b8%b1%e0%b8%9a%e0%b8%84%e0%b8%ad%e0%b8%a1%e0%b9%80%e0%b8%a1%e0%b8%99%e0%b8%95%e0%b9%8c-'
      //       }
      //     ]
      //   },
      //   {
      //     id: '10',
      //     status: true,
      //     header: '31 พฤษภาคม 2021',
      //     text: [
      //       {
      //         title: 'แก้ไขปัญหาการที่ลูกค้าแนบสลิปไม่ได้',
      //         message:
      //           'สามารถตั้งค่าการสั่งซื้อสินค้าแบบอัพโหลดสลิปภายหลังได้ เพจสามารถตั้งค่าให้ลูกค้าส่งหลักฐานการชำระเงินในแชทภายหลังได้ (ภายใน 24 ชม.) ระบบจะเก็บภาพเข้ามาอัพโหลดสลิปที่ระบบหลังบ้านให้อัตโนมัติ',
      //         link:
      //           'https://blog.zwiz.ai/%E0%B8%A7%E0%B8%B4%E0%B8%98%E0%B8%B5%E0%B9%81%E0%B8%81%E0%B9%89%E0%B9%81%E0%B8%99%E0%B8%9A%E0%B8%AA%E0%B8%A5%E0%B8%B4%E0%B8%9B%E0%B9%84%E0%B8%A1%E0%B9%88%E0%B9%84%E0%B8%94%E0%B9%89/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '09',
      //     status: true,
      //     header: '27 เมษายน 2021',
      //     text: [
      //       {
      //         title: 'ตั้งค่าการตอบกลับในเฟสบุ๊คและไลน์ให้ต่างกัน',
      //         message:
      //           'สามารถทำให้คำตอบทางเฟสบุ๊คและไลน์ เป็นคำตอบคนละชุดได้ จากปกติไม่สามารถเลือกแยกการตอบกลับได้',
      //         link: 'https://blog.zwiz.ai/ให้แชทบอทตอบใน-facebook-และ-line-ไม่/'
      //       },
      //       {
      //         title: 'หน้าวิเคราะห์รูปแบบใหม่',
      //         message:
      //           'ปรับปรุงประสิทธิภาพการทำงานให้ดียิ่งขึ้น สามารถดูข้อมูลได้ละเอียดมากขึ้น ดูการตอบกลับคอมเมนต์ตามโพสต์ที่เลือกได้',
      //         link: 'https://tinyurl.com/y2mprzbr'
      //       }
      //     ]
      //   },
      //   {
      //     id: '08',
      //     status: true,
      //     header: '21 เมษายน 2021',
      //     text: [
      //       {
      //         title: 'ตั้งค่าการแจ้งเตือน Line notify ได้ตามบทสนทนา',
      //         message:
      //           'สามารถเลือกตั้งค่าการแจ้งเตือนไปยังไลน์ส่วนตัวหรือไลน์กลุ่มที่ตั้งค่าไว้ โดยเลือกตามบทสนทนาได้ เพื่อตอบโจทย์การใช้งาน',
      //         link: 'https://blog.zwiz.ai/line-notify-แจ้งเตือนผ่านไลน์/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '07',
      //     status: true,
      //     header: '20 เมษายน 2021',
      //     text: [
      //       {
      //         title: 'ติดป้ายกำกับอัตโนมัติเมื่อลูกค้าทำการชำระเงินผ่านระบบ',
      //         message:
      //           'เมื่อลูกค้าทำการชำระเงินผ่านระบบร้านค้าครบวงจร จะถูกติดป้ายกำกับอัตโนมัติไปยังหน้ากล่องข้อความเฟสบุ๊ค “รอตรวจออเดอร์” เพื่อแจ้งเตือนเบื้องต้นสำหรับเข้ามาตรวจสอบออเดอร์ในระบบหลังบ้าน',
      //         link: 'https://tinyurl.com/yg9qkfz4'
      //       },
      //       {
      //         title: 'แนะนำโค้ดส่วนลดอัตโนมัติ',
      //         message:
      //           'เมื่อลูกค้าซื้อสินค้าตรงกับเงื่อนไขโค้ดส่วนลดของร้านค้า จะมีโค้ดส่วนลดขึ้นแนะนำอัตโนมัติให้ลูกค้าเพื่อกดใช้งานได้เลย หรือทางร้านสามารถเลือกได้ว่าต้องการแสดงโค้ดเหล่านั้นให้ลูกค้าเห็นหรือไม่ (โค้ดลับๆนั่นเอง)',
      //         link: 'https://blog.zwiz.ai/โค้ดส่วนลด-coupon/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '06',
      //     status: true,
      //     header: '19 เมษายน 2021',
      //     text: [
      //       {
      //         title: 'ตั้งค่าโหมดไม่ตอบซ้ำบทสนทนาเดิม สามารถกำหนดเวลาในการไม่ตอบกลับได้',
      //         message:
      //           'สามารถตั้งค่ากำหนดเวลาในการไม่ตอบกลับบทสนทนาเดิมที่ลูกค้าเคยถามเข้ามา โดยกำหนดเวลาไม่ตอบกลับสูงสุดได้  10,000 นาที',
      //         link: 'https://blog.zwiz.ai/ไม่อยากให้-bot-ตอบซ้ำ/'
      //       },
      //       {
      //         title: 'ใส่น้ำหนักที่ตัวเลือกสินค้า',
      //         message:
      //           'สามารถเลือกใส่น้ำหนักของสินค้าในแต่ละตัวเลือกสินค้าได้ จากปกติที่สามารถใส่น้ำหนักได้เฉพาะสินค้าหลักเท่านั้น',
      //         link: 'https://blog.zwiz.ai/tutorial-6-shopservice/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '05',
      //     status: true,
      //     header: '9 เมษายน 2021',
      //     text: [
      //       {
      //         title: 'โค้ดส่วนลดสามารถตั้งเวลาในการจัดแคมเปญได้',
      //         message:
      //           'สามารถใส่ระยะเวลาในการสร้างโค้ดส่วนลดได้  เพื่อระบุช่วงเวลาแคมเปญได้และไม่ต้องกดปิดเมื่อโค้ดหมดอายุ',
      //         link: 'https://blog.zwiz.ai/โค้ดส่วนลด-coupon/'
      //       },
      //       {
      //         title: 'จำกัดจำนวนในการตอบกลับคอมเมนต์',
      //         message:
      //           'การตั้งค่าตอบกลับคอมเมนต์สามารถจำกัดจำนวนในการตอบกลับแต่ละโพสต์ได้ และเลือกไม่ตอบซ้ำคนเดิมได้',
      //         link: 'https://blog.zwiz.ai/การตอบกลับคอมเมนต์/'
      //       }
      //     ]
      //   },
      //   {
      //     id: '04',
      //     status: true,
      //     header: '24 มีนาคม 2021',
      //     text: [
      //       {
      //         title: 'ต่ออายุแพ็กเกจโดยการสแกนคิวอาร์โค้ด',
      //         message:
      //           'ผู้ใช้งานสามารถกดที่วันใช้งานคงเหลือ และทำการต่ออายุแพ็กเกตได้อัตโนมัติ โดยไม่ต้องรอแอดมินดำเนินการ (ง่าย สะดวก และไว ^^)',
      //         link: ''
      //       }
      //     ]
      //   },
      //   {
      //     id: '03',
      //     status: true,
      //     header: '22 มีนาคม 2021',
      //     text: [
      //       {
      //         title: 'บอทเก็บค่าแบบสอบถาม',
      //         message:
      //           'แชทบอทสามารถช่วยเก็บค่าจากการสอบถามข้อมูลได้ และมีระบบในการสรุปผล เพื่อนำข้อมูลไปใช้ต่อ',
      //         link: 'https://tinyurl.com/ydzgntc5'
      //       }
      //     ]
      //   },
      //   {
      //     id: '02',
      //     status: true,
      //     header: '25 กุมภาพันธ์ 2021',
      //     text: [
      //       {
      //         title: 'รวมแชทหลายช่องทางไว้ในซีวิซ',
      //         message:
      //           'ผู้ใช้งานสามารถซื้อแพ็กเกจเสริมเพื่อตอบแชททั้งช่องทางเฟสบุ๊คและไลน์ผ่านระบบซีวิซ และสามารถรวมหลายๆเพจไว้พร้อมกันได้ด้วย',
      //         link: 'https://tinyurl.com/y9u8v7bk'
      //       }
      //     ]
      //   },
      //   {
      //     id: '01',
      //     status: true,
      //     header: '28 มกราคม 2021',
      //     text: [
      //       {
      //         title: 'เชื่อมต่อป้ายกำกับอัตโนมัติกับเฟสบุ๊ค',
      //         message:
      //           'เมื่อทำการติดป้ายกำกับบทหน้าเฟสบุ๊ค จะขึ้นที่ระบบหลังบ้านซีวิซด้วยเช่นกัน และเมื่อติดป้ายกำกับจากระบบซีวิซ ก็จะขึ้นบนหน้าเฟสบุ๊คเช่นกัน',
      //         link: 'https://blog.zwiz.ai/เชื่อมป้ายกำกับ-tag-จากเฟส/'
      //       }
      //     ]
      //   }
      // ]
    }
  },
  mounted() {
    this.getPlatformUpdate()
  },
  methods: {
    async getPlatformUpdate() {
      const vm = this
      vm.loading = true
      const response = await vm.get('page/cms-platform-update')
      if (response.success) {
        this.platFormUpdate = response.result.content_json
        this.platFormUpdate.map(item => {
          this.panel.push(item.status)
        })
        vm.loading = false
      } else {
        vm.loading = false
      }
    },
    openDialog(img, id, link) {
      const vm = this
      vm.image = img
      vm.link = link || ''
      vm.dialog = true
      vm.$emit('countClickPlatformUpdate', id)
    },
    openLinknewtab(link, id) {
      const vm = this
      if (link !== '') {
        vm.$emit('countClickPlatformUpdate', id)
        window.open(link, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/platformupdate/PlatformUpdate.vue